'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processPartner = processPartner;

var _api = require('../api');

var Api = _interopRequireWildcard(_api);

var _constants = require('../constants');

var _config = require('../config');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function processPartner(res) {
  var PARTNERS = res.data.reduce(function (map, partner) {
    partner.attributes.logoUrl = _constants.BASE_IMG_PATH + partner.attributes.logo;
    partner.attributes.logoBnUrl = _constants.BASE_IMG_PATH + partner.attributes.logobn_small;
    map[partner.attributes.id] = partner.attributes;
    return map;
  }, {});

  (0, _config.setConfig)({ PARTNERS: PARTNERS });
  return PARTNERS;
}

function get() {
  var renew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if ((0, _config.getConfig)('PARTNERS') && !renew) {
    return Promise.resolve((0, _config.getConfig)('PARTNERS'));
  }
  return Api.getPartnersRequest().then(processPartner);
}

exports.default = { get: get };